import React from 'react';
import { HeaderTemplate, TitleHeader, Stepper } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import SelectSubject from '../../modules/appeal/components/@candidate/select/SelectSubject';

interface SelectSubjectPageProps {
  title: string;
  routeSteps: { label: string }[];
}

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    left: '-18%',
    [theme.breakpoints.between('sm', 'lg')]: {
      left: '-17%',
    },
    [theme.breakpoints.between('xs', 'md')]: {
      left: '-8%',
    },
  },
}));

const SelectSubjectPage = ({ title, routeSteps }: SelectSubjectPageProps) => {
  const { classes } = useStyles();

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        <div className={classes.stepper}>
          <Stepper activeStep={0} steps={routeSteps} />
        </div>
      </HeaderTemplate>
      <SelectSubject />
    </>
  );
};

export default SelectSubjectPage;
